module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAGdJREFUOBFjYBgFsBD4////LSCmFrgFM3eI08Dw2IolTLbCvEVIHqYORDMic0CGIvNhbEYgALEJycPUg2gmZA412aMGw0Nz6AfFNrhfEAx4OkYIEWahpGNCykfTMXIIUS0OkA0d5mwAxbOM+5cEK+sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_ValighTop_normal.png
// module id = 319
// module chunks = 0